var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "finance-manage" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  ref: "searchItem",
                  attrs: {
                    "is-collapse-list": true,
                    "grid-options": _vm.gridOptions,
                    "is-append-query": true,
                    "is-simple-query": _vm.isSimpleQuery,
                    "auto-init": false,
                    "show-more-scheme": true,
                    "show-simple": true,
                    "expand-adv": true,
                    "source-page": "finance",
                    reset: "",
                    lob: _vm.sopStateLob,
                    "custom-search-items": _vm.customSearchItems,
                    "search-item-code": _vm.$t("CargoMsg.Cargo_FinancialAudit"),
                    "is-branch-cooperate": _vm.useOrderCenterMode,
                    "custom-sim-query-placeholder": _vm.$t(
                      "Message.QuickSearchBusinessNo"
                    ),
                    "config-module": "501",
                    "grid-config-module": "180301"
                  },
                  on: {
                    "update:isSimpleQuery": function($event) {
                      _vm.isSimpleQuery = $event
                    },
                    "update:is-simple-query": function($event) {
                      _vm.isSimpleQuery = $event
                    },
                    query: _vm.queryHandler,
                    advToggle: _vm.scrollCallback,
                    perConfigChange: function(value) {
                      _vm.perConfigName = value
                    },
                    refreshGrid: function() {
                      _vm.gridRefreshId += 1
                    },
                    sopStateCallBack: _vm.sopStateChange
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c("finance-btn-group", {
                        attrs: {
                          "source-view": "manageList",
                          job: _vm.job,
                          hp: _vm.financeManageHP,
                          "grid-options": _vm.gridOptions
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "min-height": "350px" }
                },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module": "180301",
                      "per-config-name": _vm.perConfigName,
                      "refresh-id": _vm.gridRefreshId,
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "column-defs": _vm.columnDefs,
                      "sum-column-defs": _vm.sumColumnDefs,
                      "row-data": _vm.rowData,
                      "wrap-text": false,
                      "enable-quick-value-convert": true,
                      "show-selected-color": false,
                      "show-row-groups": _vm.dataListDragGroup,
                      "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      girdReady: _vm.onGridReady,
                      columnRowGroupChanged: function() {
                        this$1.$refs["searchItem"].clickCollapseList()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "pagination-wrapper",
                  attrs: { id: "footer-wrapper" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "total-wrapper",
                      class: [_vm.shouldFixed ? "fixedBottom" : ""]
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSelectionCount,
                              expression: "showSelectionCount"
                            }
                          ]
                        },
                        [_vm._v(" " + _vm._s(_vm.selectionCountLabel) + " ")]
                      ),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 1,
                            staticClass: "finance-currency-total-group",
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": _vm.chargeCalculateAmount
                                ? "income"
                                : "incomeNoTax",
                              type: "both",
                              "data-provider":
                                _vm.financeManageHP.totalGroupIncome
                                  .dataProvider,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "CargoMsg.Cargo_Receivable"
                              )
                            },
                            on: { callback: _vm.incomeCallback }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 2,
                            staticClass: "finance-currency-total-group",
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": _vm.chargeCalculateAmount
                                ? "cost"
                                : "costNoTax",
                              type: "both",
                              "data-provider":
                                _vm.financeManageHP.totalGroupCost.dataProvider,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "CargoMsg.Cargo_Dues"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 3,
                            staticClass: "finance-currency-total-group",
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": _vm.chargeCalculateAmount
                                ? "realProfit"
                                : "realProfitNoTax",
                              type: "both",
                              "data-provider":
                                _vm.financeManageHP.totalGroup.dataProvider,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "CargoMsg.Cargo_Profit"
                              )
                            },
                            on: { callback: _vm.profitCallback }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("div", { staticClass: "finance-profit-rate" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "13px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.grossProfitRate")) +
                                    ":"
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                style: {
                                  "font-style": "oblique",
                                  color:
                                    _vm.profitRate.value < 0
                                      ? "#ff0000"
                                      : "#000000"
                                }
                              },
                              [_vm._v(_vm._s(_vm.profitRate.label))]
                            )
                          ])
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-count-group", {
                            staticClass: "finance-charge-count-group",
                            attrs: {
                              "data-provider":
                                _vm.financeManageHP.chargeCountGroup
                                  .dataProvider,
                              "data-field": _vm.chargeCalculateAmount
                                ? "charge_amount"
                                : "charge_amount_no_tax",
                              "basic-currency": _vm.localCurrency,
                              "new-by-job": 3,
                              "show-rmb": true,
                              "always-show": false
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("cargo-pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.appendQuery,
                        expression: "!appendQuery"
                      }
                    ],
                    attrs: {
                      "config-module": "180301",
                      total: _vm.searchConditions.total,
                      "page-count": _vm.searchConditions.pageCount,
                      page: _vm.searchConditions.pageNum,
                      limit: _vm.searchConditions.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.searchConditions, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.searchConditions,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.queryPageHandler
                    }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.appendQuery,
                          expression: "appendQuery"
                        }
                      ],
                      staticClass: "pagination-container"
                    },
                    [
                      _c("el-pagination", {
                        staticStyle: { "text-align": "left" },
                        attrs: {
                          total: _vm.searchConditions.total,
                          layout: "total"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("finance-detail", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDetail,
            expression: "showDetail"
          }
        ],
        ref: "financeDetail",
        attrs: { "view-source": _vm.detailViewSource },
        on: { backList: _vm.toBackList, exportAll2Excel: _vm.exportAll2Excel }
      }),
      _c("business-commission", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showBusinessCommission,
            expression: "showBusinessCommission"
          }
        ],
        ref: "businessCommission",
        attrs: { visible: _vm.showBusinessCommission },
        on: {
          "update:visible": function($event) {
            _vm.showBusinessCommission = $event
          },
          viewDetail: _vm.showDetail4BusinessCommission,
          backList: function($event) {
            _vm.showBusinessCommission = false
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("update-exchange-rate-dialog", {
        attrs: {
          visible: _vm.updateExchangeRateDialog.visible,
          "job-key-list": _vm.updateExchangeRateDialog.jobKeyList,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.updateExchangeRateDialog, "visible", $event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "sop-state-wrapper-grid" },
        [
          _c("sop-state-dialog", {
            attrs: {
              visible: _vm.sopStateDialog.visible,
              "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
              job: _vm.currentRow
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.sopStateDialog, "visible", $event)
              },
              "update:isNeedRefresh": function($event) {
                return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
              },
              "update:is-need-refresh": function($event) {
                return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
              },
              handleClose: _vm.sopStateDialogClose
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }